import React from 'react'

export const CallCardInfoLabel = ({ label, content, dataTestId }) => {
  return (
    <header className="call-info_label" data-testid={dataTestId}>
      {label}: <span className="call-info_text">{content}</span>
    </header>
  )
}
